import { configureStore } from "@reduxjs/toolkit";
import { createLogger } from 'redux-logger';

import rootReducer from "./rootReducer";

const logger = createLogger();
// Configure the store
const isProd = process.env.NODE_ENV === 'production';

const store = configureStore({
  reducer: rootReducer,
  middleware: (getDefaultMiddleware) => {
    const middleware = getDefaultMiddleware();

    if (!isProd) {
      // Thunk is already included by Redux Toolkit defaults.
      return middleware.concat(logger);
    }

    return middleware;
  },
});
export default store;

// import { configureStore } from "@reduxjs/toolkit";
// import rootReducer from "./rootReducer";
// const store = configureStore({
//   reducer: rootReducer,
// });
// export default store;
